import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime";
import { mark } from "regenerator-runtime";

import ionBookmarkOutline from "../../icons/ionicons/bookmark-outline.svg";
import ionBookmark from "../../icons/ionicons/bookmark.svg";

class locationView {
  #parentElement = document.querySelector(".location-img-container");
  #data;
  locationImg;
  bookmarkIcon;
  dayTimeEl;
  dateLongEl;
  timeEl;
  addImgLoadHandler;

  render(data) {
    this.#data = data;

    this.#clear();
    const markup = this.#generateMarkup();
    this.#parentElement.insertAdjacentHTML("afterbegin", markup);

    this.addImgClass();
    this.addDateTime();
    this.dayTimeSwitcher01();
    this.addBookmarkClass();
    this.renderBookmark();
  }

  #clear() {
    this.#parentElement.innerHTML = "";
  }

  displayImg() {
    this.locationImg.classList.remove("location-img-display-none");
  }

  addImgClass() {
    this.locationImg = document.querySelector(".location-img");

    this.addImgLoadHandler = function (handler) {
      this.locationImg.addEventListener(
        "load",
        function () {
          handler();
        }.bind(this)
      );
    };
  }

  addBookmarkClass() {
    this.bookmarkIcon = document.querySelector(".bookmark-container");
    this.bookmarkMarkup = this.#generateBookmarkMarkup();
  }

  renderBookmark() {
    this.addBookmarkClass();
    this.bookmarkIcon.insertAdjacentHTML("afterbegin", this.bookmarkMarkup);
  }

  #generateMarkup() {
    return `<div class="location-name-time">
    <span class="location-name">${this.#data.data.placeName}</span>
    <span class="date day-time">${this.#data.data.date}/${
      this.#data.data.monthNum
    }/${this.#data.data.year}</span>
    <span class="date-long day-time">${this.#data.data.date} ${
      this.#data.data.monthLong
    } ${this.#data.data.year}</span>
    <span class="time day-time">${this.#data.data.hour}:${
      this.#data.data.minute
    }</span>
  </div>
  
  
<figure class="figure-img">
  <img
    class="location-img location-img-display-none"
    src="${this.#data.data.returnImg()}" 
    alt="Image of ${this.#data.data.placeName}"
    
    />
  <figcaption class="figcaption-img">
  ${
    this.#data.data.returnContributor()
      ? "Image by: " + this.#data.data.returnContributor()
      : ""
  }

  </figcaption>
  
</figure>
  <div class="bookmark-container">

    </div>
   

`;
  }

  #generateBookmarkMarkup() {
    return `  <img
    class="bookmark-icon"
    src="${!this.#data.booked ? ionBookmarkOutline : ionBookmark}" 
    alt="bookmark"
    
    />`;
  }

  addDateTime() {
    this.dayTimeEl = document.querySelectorAll(".day-time");
    this.dateLongEl = document.querySelector(".date-long");
    this.timeEl = document.querySelector(".time");
  }

  dayTimeSwitcher01() {
    this.timeEl.classList.remove("day-time--active");
    this.dateLongEl.classList.remove("day-time--active");
    this.dateLongEl.classList.add("day-time--active");

    setTimeout(
      function () {
        this.dateLongEl.classList.remove("day-time--active");
        this.timeEl.classList.add("day-time--active");
        this.dayTimeSwitcher02();
      }.bind(this),
      8000
    );
  }

  dayTimeSwitcher02() {
    setTimeout(
      function () {
        this.dayTimeSwitcher01();
      }.bind(this),
      8000
    );
  }

  addHandlerBookmark(handler) {
    this.bookmarkIcon.addEventListener("click", function () {
      handler();
    });
  }
}

export default new locationView();
